"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BasePluginWindow_1 = tslib_1.__importDefault(require("./BasePluginWindow"));
/**Dosya düzenleme, kaydetme gibi çeşitli sol.exp. bağımlılıkları olmayan windowlar */
class InputWindow extends BasePluginWindow_1.default {
    constructor(id, name, plugin) {
        super(id, name, plugin);
    }
}
exports.default = InputWindow;
//# sourceMappingURL=InputWindow.js.map